// Lib
import { head } from 'lodash/fp';

// Utils
import getCompletelyOverflowingEdges from './getCompletelyOverflowingEdges';
import getOverflowingCorner from './getOverflowingCorner';
import { getRectCenterPoint } from '../../../../../common/maths/geometry/rect';

// Constants
import { RECT_CORNERS, RECT_EDGES } from '../../../../../common/maths/geometry/rect/rectConstants';

// FIXME These are for a small grid size
const EDGE_THRESHOLD_X = 40;
const EDGE_THRESHOLD_Y = 40;

const getLeftCorner = ({ centerPoint, layerRect }) => {
    if (centerPoint.y < layerRect.top + EDGE_THRESHOLD_Y) return RECT_CORNERS.TOP_LEFT;
    if (centerPoint.y > layerRect.bottom - EDGE_THRESHOLD_Y) return RECT_CORNERS.BOTTOM_LEFT;
};

const getRightCorner = ({ centerPoint, layerRect }) => {
    if (centerPoint.y < layerRect.top + EDGE_THRESHOLD_Y) return RECT_CORNERS.TOP_RIGHT;
    if (centerPoint.y > layerRect.bottom - EDGE_THRESHOLD_Y) return RECT_CORNERS.BOTTOM_RIGHT;
};

const getTopCorner = ({ centerPoint, layerRect }) => {
    if (centerPoint.x < layerRect.left + EDGE_THRESHOLD_X) return RECT_CORNERS.TOP_LEFT;
    if (centerPoint.x > layerRect.right - EDGE_THRESHOLD_X) return RECT_CORNERS.TOP_RIGHT;
};

const getBottomCorner = ({ centerPoint, layerRect }) => {
    if (centerPoint.x < layerRect.left + EDGE_THRESHOLD_X) return RECT_CORNERS.BOTTOM_LEFT;
    if (centerPoint.x > layerRect.right - EDGE_THRESHOLD_X) return RECT_CORNERS.BOTTOM_RIGHT;
};

/**
 * Finds a corner close to the target rect, if one exists, for the purposes of grouping.
 */
export default ({ targetRect, layerRect }) => {
    // Completely overflowed edges
    const overflowEdges = getCompletelyOverflowingEdges({ targetRect, layerRect });

    if (overflowEdges.length === 0) return null;

    if (overflowEdges.length === 2) return getOverflowingCorner({ targetRect, layerRect });

    // Must only be one edge here
    const centerPoint = getRectCenterPoint(targetRect);
    const overflowEdge = head(overflowEdges);

    switch (overflowEdge) {
        case RECT_EDGES.top:
            return getTopCorner({ centerPoint, layerRect });
        case RECT_EDGES.bottom:
            return getBottomCorner({ centerPoint, layerRect });
        case RECT_EDGES.left:
            return getLeftCorner({ centerPoint, layerRect });
        case RECT_EDGES.right:
            return getRightCorner({ centerPoint, layerRect });
        default:
            return null;
    }
};
